import React from 'react';
import isEmpty from 'lodash/isEmpty';
import AllhomesPropertyOfTheWeek from '@domain-group/fe-co-allhomes-property-of-the-week';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import gaHelper from '@domain-group/fe-allhomes-library/lib/utils/ga-helper';
import { OldPropertyAlertButton } from './old-property-alert-button';
import * as styles from './allhomes-listing-no-search-results.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesListingNoSearchResults = _ref => {
  var _ref$onClearFilter = _ref.onClearFilter,
    onClearFilter = _ref$onClearFilter === void 0 ? () => {} : _ref$onClearFilter,
    _ref$propertiesOfTheW = _ref.propertiesOfTheWeek,
    propertiesOfTheWeek = _ref$propertiesOfTheW === void 0 ? [] : _ref$propertiesOfTheW,
    _ref$isDefaultSearch = _ref.isDefaultSearch,
    isDefaultSearch = _ref$isDefaultSearch === void 0 ? false : _ref$isDefaultSearch,
    _ref$onPropertyAlertC = _ref.onPropertyAlertClick,
    onPropertyAlertClick = _ref$onPropertyAlertC === void 0 ? () => {} : _ref$onPropertyAlertC;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  return ___EmotionJSX("section", {
    css: styles.content
  }, ___EmotionJSX("div", {
    css: styles.contents
  }, ___EmotionJSX("img", {
    src: "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-search-results/static/no-results_ab1f0f17.png",
    css: styles.image,
    alt: "No properties match your search right now"
  }), ___EmotionJSX("div", {
    css: styles.text
  }, "No properties match your search right now. You could:"), ___EmotionJSX("ul", {
    css: styles.actions
  }, ___EmotionJSX("li", null, "Change your search locations,", isDefaultSearch && ' or'), ___EmotionJSX("li", null, ___EmotionJSX(OldPropertyAlertButton, {
    buttonLabel: "Create a property alert",
    onPropertyAlertClick: onPropertyAlertClick,
    type: "link",
    targetUrl: getAbsoluteUrl('/property-alerts')
  }), ' ', "for this search", isDefaultSearch || ', or'), isDefaultSearch || ___EmotionJSX("li", null, ___EmotionJSX("button", {
    type: "button",
    onClick: onClearFilter,
    css: styles.button
  }, "Clear all filters"), ' ', "and start again."))), !isEmpty(propertiesOfTheWeek) && ___EmotionJSX("div", {
    css: styles.powWrapper
  }, ___EmotionJSX(AllhomesPropertyOfTheWeek, {
    listings: propertiesOfTheWeek,
    onClick: (_unused, index) => {
      gaHelper.interactionEvent("Property of the Week - Position ".concat(index + 1), '');
    }
  })));
};
export default AllhomesListingNoSearchResults;